
    import C1HelpText from '@/C1Components/C1HelpText';
    import C1Label from '@/C1Components/C1Label';

    const INPUT_SIZES = ['sm', 'md', 'lg'];

    export default {
        name: 'C1FormTextarea',

        components: {
            C1HelpText,
            C1Label,
        },

        props: {
            value: {
                type: String,
                default: '',
            },

            id: {
                type: String,
                default: '',
            },

            placeholder: {
                type: String,
                default: '',
            },

            name: {
                type: String,
                default: '',
            },

            size: {
                type: String,
                default: 'md',
                validator: value => INPUT_SIZES.includes(value),
            },

            isInvalid: {
                type: Boolean,
                default: false,
            },

            invalidFeedback: {
                type: String,
                default: '',
            },

            label: {
                type: String,
                default: '',
            },

            rows: {
                type: [String, Number],
                default: 4,
            },
        },

        data() {
            return {
            };
        },

        computed: {
            classList() {
                return [
                    'appearance-none rounded w-full transition duration-150 ease-in-out',
                    this.getTextColorClass,
                    this.getTextSizeClass,
                    this.getBorderClass,
                    this.getPaddingClass,
                ];
            },

            getTextColorClass() {
                return 'text-c1-gray-500 placeholder-c1-cool-gray-300';
            },

            classEyeIconList() {
                return this.isInvalid ? 'text-c1-red-400' : 'text-c1-cool-gray-400';
            },

            getTextSizeClass() {
                switch (this.size) {
                    case 'sm':
                        return 'text-sm leading-4';
                    case 'md':
                        return 'text-sm leading-5';
                    case 'lg':
                        return 'text-base leading-6';
                    default:
                        return '';
                }
            },

            getBorderClass() {
                let output = 'border focus:outline-none ';
                if (this.isInvalid) {
                    output += 'border-c1-red-400 focus:border-c1-red-500';
                } else {
                    output += 'border-c1-cool-gray-200 focus:border-c1-blue-400';
                }

                return output;
            },

            getPaddingClass() {
                switch (this.size) {
                    case 'sm':
                        return 'py-2 px-3';
                    case 'md':
                        return 'py-2 px-3';
                    case 'lg':
                        return 'py-3 px-6';
                    default:
                        return '';
                }
            },

            inputListeners() {
                const vm = this;
                return {
                    ...this.$listeners,
                    input(event) {
                        vm.$emit('input', event.target.value);
                    },
                    change(event) {
                        vm.$emit('change', event.target.value);
                    },
                    blur(event) {
                        vm.$emit('blur', event);
                    },
                };
            },
        },
    };
